module.exports = __webpack_public_path__ + "static/img/0402_02.5a539c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_02.png
// module id = BsvT
// module chunks = 1